import React from 'react';
import './blog-post.css';
import video from "./pictures/wad_video.mp4";
import wad1 from './pictures/wad1.jpg';
import wad2 from './pictures/wad2.jpg';
import wad3 from './pictures/wad3.jpg';
import wad4 from './pictures/wad4.jpg';
import wad5 from './pictures/wad5.jpg';
import wad6 from './pictures/wad6.jpg';


//import reportWebVitals from './reportWebVitals';

const WAD = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Winter Affiliates Dinner Recap</h2>
                    <p class="site-post-meta">January 31st, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Last Wednesday, we had our WiC Winter Affiliates Dinner! 
                    We had over 70 members join us in a night of networking with 
                    representatives from Google, Meta, Uber, Moloco, F5, and Hiya in 
                    speed dating, Q&A panel, and yummy dinner from Buca di Beppo. 

                    <br></br>
                     
                    </p>
                    <video src={video} width="800" height="500" controls="controls" autoplay="false" />
                    <img src={wad1} alt="Group picture"/>
                    <img src={wad2} alt="Group picture of speaker panelists"/>
                    <img src={wad3} alt="Speed dating round table 1"/>
                    <img src={wad4} alt="Speed dating round table 2"/>
                    <img src={wad5} alt="Speaker panel"/>
                    <img src={wad6} alt="Dinner"/>
                 
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default WAD;

